import { getApis } from "library/Apis";
import { RespostaMultiplosPerfisDTO } from "models/pesquisa";
import { toRequest } from "utils/RequestUtils";

const getEndpoint = (version: number, path = '/', basePath = 'pesquisa/v') => {
    return `${getApis().apis.bff}${basePath}${version}${path}`
}

export const getRespondidoMultiplosPerfis = () => {
    const url = getEndpoint(1, '/multiplos-perfis');
    return toRequest('get', [url])
}

export const postRespostaMultiplosPerfis = (request: RespostaMultiplosPerfisDTO) => {
    const url = getEndpoint(1, '/multiplos-perfis/responder')
    return toRequest('post', [url, request])
}
